export default {
  "bookKeeping.account": "勘定科目",
  "bookKeeping.entry1": "補助科目1",
  "bookKeeping.entry2": "補助科目2",
  "bookKeeping.journal": "仕訳連携設定",

  "bookKeeping.journal.partner": "取引先",
  "bookKeeping.journal.subclass": "補助科目分類",
  "bookKeeping.journal.dept": "取引部門",

  "bookKeeping.journal.reprintCountCC": "チケット再印刷回数（自動券売機）",
  "bookKeeping.journal.reprintCountPOS": "チケット再印刷回数（POS）",
  "bookKeeping.journal.reprintInvoiceCountPOS": "領収書再印刷回数（POS）",
  "bookKeeping.journal.reprintReceiptCountPOS": "レシート再印刷回数（POS）",
}